import { handleKeyDown } from "../../utils/utils";


type ButtonModifyRecapInfoProps = Readonly<{
    isDisplayed: boolean | null;
    handleClick: () => void;
}>;
 
 export default function ButtonModifyRecapInfo({isDisplayed, handleClick}: ButtonModifyRecapInfoProps) { 
    if (isDisplayed) {
        return (
          <div className="edition mb-sm"  onClick={handleClick} role='button' tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}>
            <p className="link-bleu edit">
              Modifier
            </p>
            <i className="icon-crayon fushia fz-xs fz-xs"></i>
          </div>
        )
      } else {
        return <div></div>
      }
  
 }